<template>

  <b-card
    no-body
    class="mb-1 bg-light-primary rounded"
  >
    <b-card-header
      header-tag="header"
      class="p-1"
      role="tab"
    >
      <b-button
        v-b-toggle.accordion-asesor
        block
        variant="primary"
      >
        INSTRUCCIONES PARA VALIDAR CALIFICACIONES
      </b-button>
    </b-card-header>

    <b-collapse
      id="accordion-asesor"
      visible
      accordion="my-accordion"
    >

      <b-card-text class="p-2">

        <p><strong>¡Importante! Si le aparece la leyenda "Sin Calificar" comuníquese a Control Escolar para que realicen el pre cierre antes de continuar.</strong></p>
        <ol>
          <li>Paso 1 - Seleccione: Plan de estudios, Periodo y Curso; Después <b>revise cada calificación</b> de cada alumno.</li>
          <li>Paso 2 - (Opcional) Si algún alumno requiere una <b>modificacion de calificación</b>, capture la nueva calificación y la justificación. (Al hacer clic en "Terminar y validar", la modificación será registrada, común mente son los alumnos que presentan exámen de acreditación).</li>
          <li>Paso 3 - <b>Haga clic en terminar y validar.</b>
          </li>
        </ol>

        <p><strong>Repita este procedimiento para cada curso correspondiente al plan de estudios y periodo seleccionados.</strong></p>
      </b-card-text>

    </b-collapse>
  </b-card>

</template>

<script>
import {
  BCard, BCardHeader,
  BButton, BCardText,
  BCollapse, VBToggle,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'

import store from '@/store'

export default {
  components: {
    BCollapse,
    BCard,
    BCardText,
    BButton,
    BCardHeader,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  setup() {
    const userRole = computed(() => store.state.cuenta.rolSelected)

    return {
      userRole,
    }
  },
}
</script>
